const UPDATED_SYMBOL = Symbol('tws-filter-record-updated');
function addSymbolToRecord(record) {
    return {
        ...record,
        [UPDATED_SYMBOL]: new Date(),
    };
}
function compareRecordSymbol(recordA, recordB) {
    const valueA = recordA[UPDATED_SYMBOL];
    const valueB = recordB[UPDATED_SYMBOL];
    return valueA === valueB;
}
export { addSymbolToRecord, compareRecordSymbol, };
//# sourceMappingURL=filter-symbol.js.map